module.exports = __webpack_public_path__ + "img/73.95d5a33b.jpg";